import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const ComputerScienceCareerSkills = () => {
  return (
    <CareerSkillsSection
      title="COMPUTER SCIENCE SKILLS? CHECK."
      paragraphs={[
        `In Computer Science at JRIIT, you'll get an education built on core programs that are vital for success in today's digital age — technical expertise in programming, algorithms, data structures, and software engineering. These are the skills that employers say make JRIIT Computer Science graduates stand out. Our Computer Science program offers both a 1-year Certificate for foundational skills and a 2-year Diploma for advanced specialization in cutting-edge technologies.`,

        `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you'll receive detailed feedback on your technical strengths and where you can improve, giving you a more complete picture of your growth.`,

        `Discover our Computer Science programs below and unlock the skills to shape your future.`,
      ]}
    />
  );
};

export default ComputerScienceCareerSkills;
